import { StepParams, ContainerTypes } from '@/types/containerTypes';
import { Step } from './step';

export class FunctionCall extends Step {
  constructor(params: StepParams) {
    super(params);
    this.containerType = ContainerTypes.FunctionCall;
  }
}
